import React from "react";
import ReactLoading from "react-loading";

const LoadingIcon = ({ type }) => {
  return (
    <div className="load-container">
      <ReactLoading type={type} color="black" className="loading-icon" />
    </div>
  );
};

export default LoadingIcon;
